import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Space, Table, Input } from 'antd'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import { useTableDataSourceKey } from '~/hooks/useTableDataSourceKey'
import { compareNumber, compareText } from '~/utils/helpers'
import { useCoursesQuery } from './query'

const columns = () => [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: (a, b) => compareNumber(a.id, b.id)
  },
  {
    title: 'Title',
    render: (course) => <Link to={`/user/courses/${course.id}/cases`}>{course.name}</Link>,
    sorter: (a, b) => compareText(a.name, b.name)
  },
  {
    title: 'Case-uploading',
    render: (course) => {
      if (!course.case_uploaders) {
        return ''
      }

      return (
        <div>
          {course.case_uploaders.map((i) => (
            <div key={i.id}>- {i.name}</div>
          ))}
        </div>
      )
    }
  },
  {
    title: '# of cases',
    render: (course) => {
      return course?.uploaded_cases.length
    }
  },
  {
    title: 'Cases',
    render: (course) => {
      return (
        <Space size="middle">
          <Link to={`/user/courses/${course.id}/cases`}>
            <Button type="primary" icon={<EyeOutlined />} />
          </Link>
        </Space>
      )
    }
  }
]
const DoctorCases = () => {
  const { data: courses, isLoading: coursesLoading } = useCoursesQuery()
  const coursesSource = useTableDataSourceKey(courses)
  const [filterInput, setFilterInput] = useState('')

  const filterCourses = useMemo(() => {
    const filter = filterInput.toLowerCase()
    if (!coursesSource) {
      return 0
    }

    return coursesSource.filter((course) => course.name.toLowerCase().includes(filter))
  }, [coursesSource, filterInput])

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title="Cases"
        extra={[
          <Input.Search
            key={1}
            placeholder="Search"
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
          />
        ]}
      />
      <Table
        size="small"
        tableLayout="auto"
        dataSource={filterCourses}
        columns={columns()}
        loading={coursesLoading}
      />
    </>
  )
}

export default DoctorCases
